import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import { FC } from 'react';
import {
  AutoCompleteOption,
  StyledTableCellHead,
  TableFormFooter,
} from '@bom-nextgen-keycloak/web/shared/ui';
import { TableContainer } from './UserFormTable.styled';

type UserFormTableProps = {
  data: AutoCompleteOption[];
  disabled?: boolean;
  onRemove: (data: AutoCompleteOption) => void;
};

const UserFormTable: FC<UserFormTableProps> = ({
  data,
  disabled = false,
  onRemove,
}) => {
  const totalRecord = data.length;

  return (
    <Paper>
      <TableContainer>
        <Table aria-label="user table" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCellHead>Name</StyledTableCellHead>
              <StyledTableCellHead>Email</StyledTableCellHead>
              <StyledTableCellHead>Username</StyledTableCellHead>
              <StyledTableCellHead>ID</StyledTableCellHead>
              <StyledTableCellHead align="center" sx={{ width: '85px' }}>
                Actions
              </StyledTableCellHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item) => {
              const { label = '', value } = item;
              const { email, id, name } = value;

              return (
                <TableRow key={id}>
                  <TableCell>{name || '-'}</TableCell>
                  <TableCell>{email || '-'}</TableCell>
                  <TableCell>{label}</TableCell>
                  <TableCell>{id}</TableCell>
                  <TableCell align="center">
                    <Tooltip title="Remove user">
                      <IconButton
                        aria-label="delete"
                        onClick={() => onRemove(item)}
                        size="small"
                      >
                        <DeleteIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TableFormFooter>
        <b>{`${totalRecord} user${totalRecord > 1 ? 's' : ''}`}</b> selected
      </TableFormFooter>
    </Paper>
  );
};

export { UserFormTable };
